<nz-divider
    class="no-margin"
    nzPlain="true"
    [nzText]="text"
    nzOrientation="left"
>
    <ng-template #text>
        <div class="sider-divider-text">{{ getColumnLabel() }}</div>
    </ng-template>
</nz-divider>
<div class="date-container">
    <nz-select
        [(ngModel)]="selectedPresetModel"
        (ngModelChange)="onUIPresetChange($event)"
        nzSize="small"
        [nzOptionHeightPx]="25"
        [nzDropdownMatchSelectWidth]="false"
        nzPlaceHolder="Select range preset"
    >
        <nz-option
            *ngFor="let option of this.rangePresetIds"
            [nzValue]="option"
            [nzLabel]="option"
            >{{ option }}</nz-option
        >
    </nz-select>

    <!-- Relative date range setup section -->
    <div style="display: flex; gap: 2px">
        <nz-input-group nzCompact style="display: flex; width: 50%">
            <nz-input-number
                nzSize="small"
                [ngModel]="relativeStartUnitCountModel"
                (ngModelChange)="
                    onUIRelativeChange('start', $event, relativeStartUnitModel)
                "
                [nzPlaceHolder]="'Start'"
                min="0"
            ></nz-input-number>
            <nz-select
                style="flex-grow: 1"
                nzSize="small"
                [nzOptionHeightPx]="25"
                [nzDropdownMatchSelectWidth]="false"
                [ngModel]="relativeStartUnitModel"
                (ngModelChange)="
                    onUIRelativeChange(
                        'start',
                        relativeStartUnitCountModel,
                        $event
                    )
                "
            >
                <nz-option
                    *ngFor="let unit of RELATIVE_UNITS"
                    [nzValue]="unit"
                    [nzLabel]="unit"
                    >{{ unit }}</nz-option
                >
            </nz-select>
        </nz-input-group>
        <nz-input-group nzCompact style="display: flex; width: 50%">
            <nz-input-number
                nzSize="small"
                type="number"
                [ngModel]="relativeEndUnitCountModel"
                (ngModelChange)="
                    onUIRelativeChange('end', $event, relativeEndUnitModel)
                "
                [nzPlaceHolder]="'End'"
                min="0"
            ></nz-input-number>
            <nz-select
                style="flex-grow: 1"
                nzSize="small"
                [nzOptionHeightPx]="25"
                [nzDropdownMatchSelectWidth]="false"
                [ngModel]="relativeEndUnitModel"
                (ngModelChange)="
                    onUIRelativeChange('end', relativeEndUnitCountModel, $event)
                "
            >
                <nz-option
                    *ngFor="let unit of RELATIVE_UNITS"
                    [nzValue]="unit"
                    [nzLabel]="unit"
                    >{{ unit }}</nz-option
                >
            </nz-select>
        </nz-input-group>
    </div>
    <div class="range-input">
        <button
            nz-button
            nzType="default"
            (click)="onUIShiftPeriod('previous')"
            [disabled]="!canShiftPeriod()"
            nz-tooltip
            [nzTooltipTitle]="cannotShiftPeriodReason"
            nzSize="small"
        >
            &lt;
        </button>
        <nz-date-picker
            class="range-single-input"
            [(ngModel)]="startDateModel"
            nzSize="small"
            [nzAllowClear]="true"
            [nzPlaceHolder]="'Start date'"
            (ngModelChange)="onUIDateChange('start', $event)"
            [nzFormat]="DATE_FORMAT"
        >
        </nz-date-picker>
        <nz-date-picker
            class="range-single-input"
            [(ngModel)]="endDateModel"
            nzSize="small"
            [nzAllowClear]="true"
            [nzPlaceHolder]="'End date'"
            (ngModelChange)="onUIDateChange('end', $event)"
            [nzFormat]="DATE_FORMAT"
            [nzSuffixIcon]="suffixIcon"
        >
        </nz-date-picker>
        <!-- TemplateRef for icon -->
        <ng-template #suffixIcon>
            <!-- Icon is black if relativeEndDateUnitCountModel is undefined -->
            <span
                nz-icon
                nzType="calendar"
                nzTheme="outline"
                [style]="
                    this.relativeEndUnitCountModel === undefined &&
                    this.endDateModel !== undefined
                        ? 'color: black'
                        : 'color: rgba(0, 0, 0, 0.25);'
                "
            ></span>
        </ng-template>

        <button
            nz-button
            nzType="default"
            (click)="onUIShiftPeriod('next')"
            [disabled]="!canShiftPeriod()"
            nz-tooltip
            [nzTooltipTitle]="cannotShiftPeriodReason"
            nzSize="small"
        >
            &gt;
        </button>

        <!-- clearDataInput() -->
    </div>
    <div class="split">
        <nz-select
            *ngIf="
                dashboardItem.options.splitable ||
                dashboardItem.options.forcedSplitable
            "
            [(ngModel)]="dateAggModel"
            (ngModelChange)="onUIDateAggChange($event)"
            nzSize="small"
            [nzOptionHeightPx]="25"
            [nzDropdownMatchSelectWidth]="false"
            nzPlaceHolder="Select split aggregation"
        >
            <nz-option
                *ngFor="let option of DATE_SPLIT_AGGREGATES"
                [nzValue]="option"
                [nzLabel]="option"
                >{{ option }}</nz-option
            >
        </nz-select>
        <label
            nz-checkbox
            *ngIf="
                dashboardItem.options.splitable &&
                !dashboardItem.options.forcedSplitable
            "
            [ngModel]="isSplitAppliedModel"
            (ngModelChange)="onUISplitChange($event)"
            >Split</label
        >
    </div>
</div>
